/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyInfo,
    JsonCompanyInfoFromJSON,
    JsonCompanyInfoFromJSONTyped,
    JsonCompanyInfoToJSON,
} from './JsonCompanyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonCompanyInfo
 */
export interface ApiResultOfListOfJsonCompanyInfo {
    /**
     * 
     * @type {Array<JsonCompanyInfo>}
     * @memberof ApiResultOfListOfJsonCompanyInfo
     */
    data?: Array<JsonCompanyInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonCompanyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyInfo
     */
    result?: ApiResultOfListOfJsonCompanyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonCompanyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonCompanyInfoFromJSON(json: any): ApiResultOfListOfJsonCompanyInfo {
    return ApiResultOfListOfJsonCompanyInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonCompanyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonCompanyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonCompanyInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonCompanyInfoToJSON(value?: ApiResultOfListOfJsonCompanyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonCompanyInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

